import { render } from "./PlaySoundEditorCmp.vue?vue&type=template&id=1ecdbc59"
import script from "./PlaySoundEditorCmp.vue?vue&type=script&lang=js"
export * from "./PlaySoundEditorCmp.vue?vue&type=script&lang=js"

import "./PlaySoundEditorCmp.vue?vue&type=style&index=0&id=1ecdbc59&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__